import { post } from "../../services";
import { LIST_MOKSHA_STAFF, SEARCH_HOTEL_STAFF, SET_MOKSHA_STAFF } from "../../graphql";
import { TOGGLE_LOADING } from "../types";

export const listMokshaStaff = (pageNumber = 1, pageSize = 10) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        let apiResponse = await post("", {
            query: LIST_MOKSHA_STAFF,
            variables: { pageNumber, pageSize },
        });

        dispatch({ type: TOGGLE_LOADING, payload: false });
        if (apiResponse.data.customStatus) {
            return apiResponse.data.data.list_moksha_staff;
        }
        return null;
    };
};

// Returns the whole payload, not just data: `result` carries the three real answers
// (staff / property_owner / not_found) and the screen says something different for each.
export const searchHotelStaff = (email) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        let apiResponse = await post("", {
            query: SEARCH_HOTEL_STAFF,
            variables: { email },
        });

        dispatch({ type: TOGGLE_LOADING, payload: false });
        if (apiResponse.data.customStatus) {
            return apiResponse.data.data.search_hotel_staff;
        }
        return null;
    };
};

export const setMokshaStaff = (staffId, isMokshaStaff) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        let apiResponse = await post("", {
            query: SET_MOKSHA_STAFF,
            variables: { staffId, isMokshaStaff },
        });

        dispatch({ type: TOGGLE_LOADING, payload: false });
        if (apiResponse.data.customStatus) {
            return apiResponse.data.data.set_moksha_staff.message;
        }
        return null;
    };
};
